import './css/styles.scss';
// import Swiper JS
import Swiper from 'swiper';
import { Pagination, Mousewheel } from 'swiper/modules';
import { SwiperOptions } from 'swiper/types';
import type { SwiperContainer } from 'swiper/element';

function InitBlock() {
	const sliders = document.querySelectorAll('.js-kortblock-swiper');

	sliders.forEach((slider) => {
		let swiperInstance = null;

		const setupSwiper = () => {
			if (window.innerWidth <= 767 && !swiperInstance) {
				swiperInstance = new Swiper(slider, {
					modules: [Pagination],
					slidesPerView: 1.15,
					spaceBetween: 16,
					pagination: {
						el: slider.querySelector('.swiper-pagination'),
						clickable: true,
					},
				});
			}

			if (window.innerWidth > 767 && swiperInstance) {
				swiperInstance.destroy(true, true);
				swiperInstance = null;
			}
		};

		setupSwiper();
		window.addEventListener('resize', setupSwiper);
	});
}
document.addEventListener('DOMContentLoaded', function () {
	InitBlock();
});
